const React = require('react')
const { useState, useEffect } = require('react')
const { useLocation } = require('react-router-dom')
const { Container, Col, Row } = require('reactstrap')
const { useBlockchainData } = require('@hooks')
const { useNetworkConfig } = require('@contexts')
const { LoadingSpinner, Boxes } = require('@components')
const { TableHeader, TableFooter } = require('@components/table')
const { BlocksTableVersion1 } = require('./table_v1.blocks')
const { BlocksTableVersion2 } = require('./table_v2.blocks')

require('@styles/pages/blocks/index.css')

const Blocks = () => {
    const location = useLocation()
    const { network } = useNetworkConfig()
    const { getBlocks } = useBlockchainData(network.name)

    const [statisticsData, setStatisticsData] = useState([])

    const params = new URLSearchParams(location.search)

    const [page, setPage] = useState(Number(params.get('p')) || 1)
    const [limit, setLimit] = useState(Number(params.get('ps')) || 25)
    const [blocksData, setBlocksData] = useState()

    const [loading, setLoading] = useState(false)

    const isBlockchain_1 = network.data.type === 'Ethereum 1.0'
    const isBlockchain_2 = network.data.type === 'Ethereum 2.0'

    useEffect(() => {
        const params = new URLSearchParams(location.search)
        const pageParam = Number(params.get('p'))
        const limitParam = Number(params.get('ps'))

        if (pageParam && pageParam > 0 && pageParam !== page) {
            setPage(pageParam)
        }

        if (limitParam && limitParam > 0 && limitParam !== limit) {
            setLimit(limitParam)
        }
    }, [location.search])

    useEffect(() => {
        const fetchData = async () => {
            setLoading(true)

            try {
                const [blocksResponse] = await Promise.all([getBlocks(page, limit)])

                if (blocksResponse) {
                    setBlocksData(blocksResponse)

                    setStatisticsData([
                        { title: 'Network Utilization (24H)', value: '50.5%' },
                        {
                            title: 'Last Safe Block',
                            value: (blocksResponse.totalItems - 1).toLocaleString()
                        },
                        {
                            title: 'Produced by MEV builders (24H)',
                            value: '92%'
                        },
                        { title: 'Burnt Fees 🔥', value: `4,555,502.06 ${network.data.token}` }
                    ])
                }
            } catch (error) {
                console.error('Error fetching data:', error)
            } finally {
                setLoading(false)
            }
        }

        fetchData()
    }, [network, page, limit])

    return (
        <div className='page'>
            <Container>
                <Col>
                    <Row>
                        <div className='page-header'>
                            <text className='page-title'>Blocks</text>
                            <div className='page-title-border' />
                        </div>
                    </Row>
                    {/* <Boxes items={statisticsData} /> */}

                    <div className='box table-section' style={{ padding: '24px 24px 0' }}>
                        {loading ? (
                            <div
                                className='d-flex justify-content-center align-items-center'
                                style={{ height: '300px' }}
                            >
                                <LoadingSpinner />
                            </div>
                        ) : (
                            <>
                                <TableHeader
                                    title={`Total of ${blocksData?.totalItems.toLocaleString()}
                                    blocks`}
                                    subtitle={
                                        blocksData?.items.length > 0
                                            ? `(Showing blocks between #${blocksData.items[
                                                  blocksData.items.length - 1
                                              ].number.toLocaleString()} to #${blocksData.items[0].number.toLocaleString()})`
                                            : null
                                    }
                                    page={page}
                                    limit={limit}
                                    totalPages={blocksData?.totalPages}
                                />

                                {isBlockchain_1 ? (
                                    <BlocksTableVersion1 data={blocksData?.items} />
                                ) : (
                                    <BlocksTableVersion2 data={blocksData?.items} />
                                )}
                                <TableFooter
                                    limit={limit}
                                    setLimit={setLimit}
                                    page={page}
                                    setPage={setPage}
                                    totalPages={blocksData?.totalPages}
                                />
                            </>
                        )}
                    </div>
                </Col>
            </Container>
        </div>
    )
}

module.exports = Blocks
